// extracted by mini-css-extract-plugin
module.exports = {"small":"StyledRate_small__-QtPj"};